import { render } from "./DialogAddBadge.vue?vue&type=template&id=40d3eb9a&ts=true"
import script from "./DialogAddBadge.ts?vue&type=script&lang=ts"
export * from "./DialogAddBadge.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__